<template>
  <span class="component-body">{{indicator | pluralized}}</span>
</template>

<script>
export default {
  props: {
    indicator: {
      required: true,
      type: Object,
    },
  },
  filters: {
    pluralized(indicator) {
      const base = `${indicator.plannable} / ${indicator.total} planificable`;
      return indicator.plannable === 1 ? base : `${base}s`;
    },
  },
  name: 'Indicator',
};
</script>

<style lang="scss" scoped>
  .component-body {
    margin: 6px;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 3px;
    display: inline-block;
    background-color: #f4f4f4;
  }
</style>
